import { useCallback, useMemo } from 'react'
// import PropTypes from 'prop-types';
import { isNumber, isEmpty } from 'lodash'
import { useSelector } from 'react-redux'

import PharmacySearch from '../../components/visit-creation/PharmacySearch'
import * as PharmacySelectors from '../../redux/selectors/pharmacies'
import PropTypes from 'prop-types'
import withPharmacyControl from '../../hoc/withPharmacyControl'
import { objectIdPropTypeRequired } from '../../proptypes/helpers/object-id'
import withCustomAlert from '../../hoc/withCustomAlert'
import { getMember } from '../../redux/selectors/members'
import Loading from '@ui-components-3/ui/lib/components/Loading'
import { getPreferredAddress } from '../../util/member'
import withDialog from '../../hoc/withDialog'

const buildInitialValues = (member) => {
  const address = getPreferredAddress(member)
  return {
    // keyword: '',
    storeName: '',
    city: address?.city ?? '',
    state: address?.state ?? '',
    zip: '',
    distance: '',
    specialty: ['retail'],
    lat: null,
    lng: null,
  }
}

const transformSearchValues = (values) => {
  return Object.keys(values).reduce((acc, key) => {
    if (isNumber(values[key]) || !isEmpty(values[key])) {
      acc[key] = values[key]
    }
    return acc
  }, {})
}

const PharmacySearchContainer = (props) => {
  const { memberId, onSelectionMade, addPharmacy, fetchPharmacies, showAlert, onSearchSuccess, showResults } = props

  const member = useSelector(getMember(memberId))

  const handleFormSubmit = useCallback(
    async (values, form) => {
      const filter = transformSearchValues(values)
      const { success, count } = await fetchPharmacies(filter)
      if (!success || count === 0) {
        showAlert({
          title: 'Error',
          body: 'No pharmacies found',
          showButtons: false,
          titleStyle: '!text-fuchsia-800',
        })
      } else {
        onSearchSuccess?.(count)
      }
      form.resetForm({ ...form, values })
    },
    [fetchPharmacies, onSearchSuccess, showAlert],
  )

  const initialValues = useMemo(() => buildInitialValues(member), [member])

  const pharmacies = useSelector(PharmacySelectors.getNonMemberPharmacies)
  const mailOrderPharmacies = useSelector(PharmacySelectors.getNonMemberMailOrderPharmacies)

  const handlePharmacyClick = useCallback(
    (pharmacy) => async () => {
      const { success } = await addPharmacy(pharmacy)
      if (success) {
        onSelectionMade(pharmacy)
      }
    },
    [onSelectionMade, addPharmacy],
  )

  if (!member) {
    return <Loading variant="big" shown />
  }

  return (
    <PharmacySearch
      {...props}
      onSubmit={handleFormSubmit}
      initialValues={initialValues}
      addPharmacy={handlePharmacyClick}
      searchResults={showResults ? pharmacies.concat(mailOrderPharmacies) : []}
    />
  )
}

PharmacySearchContainer.propTypes = {
  memberId: objectIdPropTypeRequired,
  onSelectionMade: PropTypes.func.isRequired,
  addPharmacy: PropTypes.func.isRequired,
  fetchPharmacies: PropTypes.func.isRequired,
  showAlert: PropTypes.func.isRequired,
  onSearchSuccess: PropTypes.func.isRequired,
  showResults: PropTypes.bool.isRequired,
}

export default withDialog(withPharmacyControl(withCustomAlert(PharmacySearchContainer)))
